// @ts-nocheck
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { FilterDrawerAndButtonPresentationProps } from "@store/Library/Components/FilterDrawerAndButton";
import { QuickSearchFieldPresentationProps } from "@store/Library/Components/QuickSearchField";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export interface QuickSearchAndFilterProps {
    filterDrawerAndButton?: FilterDrawerAndButtonPresentationProps;
    quickSearchField?: QuickSearchFieldPresentationProps;
    quickSearchWrapper?: InjectableCss;
}

export const quickSearchAndFilterProps: QuickSearchAndFilterProps = {
    quickSearchWrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            align-items: flex-end;
            gap: ${pxToRem(16)};

            ${breakpoint("lg")} {
                gap: ${pxToRem(16, 32)};
            }
        `,
    },
    quickSearchField: {
        extendedStyles: {
            textField: {
                cssOverrides: {
                    formField: css`
                        width: auto;
                        flex-grow: 999999;
                    `,
                },
            },
        },
    },
};
